import {Enum} from 'enumify'

class IntervalParser extends Enum {}
IntervalParser.initEnum({
  SPECIAL: {
    apiName: 'SPECIAL',
    capitalizedText: 'All-Season',
    daysLong: -1,
    isRecurring: true,
    lowercase: 'special'
  },
  WEEKLY: {
    apiName: 'WEEKLY',
    capitalizedText: 'Weekly',
    daysLong: 7,
    isRecurring: true,
    lowercase: 'weekly'
  },
  BIWEEKLY: {
    apiName: 'BIWEEKLY',
    capitalizedText: 'Bi-Weekly',
    daysLong: 14,
    isRecurring: true,
    lowercase: 'biweekly'
  },
  MONTHLY: {
    apiName: 'MONTHLY',
    capitalizedText: 'Monthly',
    daysLong: 28,
    isRecurring: true,
    lowercase: 'monthly'
  },
  BIMONTHLY: {
    apiName: 'BIMONTHLY',
    capitalizedText: 'Bi-Monthly',
    daysLong: 56,
    isRecurring: true,
    lowercase: 'bimonthly'
  },
  YEARLY: {
    apiName: 'YEARLY',
    capitalizedText: 'Yearly',
    daysLong: 365,
    isRecurring: true,
    lowercase: 'yearly'
  },
  BIYEARLY: {
    apiName: 'BIYEARLY',
    capitalizedText: 'Bi-Yearly',
    daysLong: 730,
    isRecurring: true,
    lowercase: 'biyearly'
  },
  TRIYEARLY: {
    apiName: 'TRIYEARLY',
    capitalizedText: 'Tri-Yearly',
    daysLong: 1095,
    isRecurring: true,
    lowercase: 'triyearly'
  },
  ONE_TIME: {
    apiName: 'ONE_TIME',
    capitalizedText: 'One-time',
    daysLong: 0,
    isRecurring: false,
    lowercase: 'one_time'
  },
  UNSCHEDULED: {
    apiName: 'UNSCHEDULED',
    capitalizedText: 'Unscheduled',
    daysLong: -1,
    isRecurring: false,
    lowercase: 'unscheduled'
  }
})
export function getIntervalParser (apiName) {
  for (const interval of IntervalParser.enumValues) {
    if (interval.apiName === apiName) {
      return interval
    }
  }
}
export default IntervalParser



// WEBPACK FOOTER //
// ./src/components/shared/enums/interval-enum-parser.js